export default function getOpenInstall(detailId, channelId, appKey) {
    /// openinstall.js中提供的工具函数，解析url中的所有查询参数
    const data = OpenInstall.parseUrlParams();
    data.detail_id = detailId;
    data.channel_id = channelId;
    // OpenInstall初始化时将与openinstall服务器交互，应尽可能早的调用
    /* web页面向app传递的json数据(json string/js Object)，应用被拉起或是首次安装时，通过相应的android/ios api可以获取此数据 */
    new OpenInstall(
        {
            // appKey必选参数，openinstall平台为每个应用分配的ID
            appKey,
            onready: function () {
                // 在app已安装的情况尝试拉起app
                this.schemeWakeup();
                const m = this;
                m.wakeupOrInstall();
                /* 跳过scheme拉起，直接安装 */
                // m.install();
                return false;
            },
        },
        data
    );
}
